const WINDOWS_EXECUTABLE_MAGIC_NUMBER = [0x4d, 0x5a] as const; // MZ

export const executableUploadBlockedMessage =
  'Invalid file - Executable files are not allowed, even if the extension is changed.';

function isBlobLike(file: unknown): file is Blob {
  return !!file && typeof (file as Blob).slice === 'function';
}

async function readFileHeaderBytes(file: Blob, bytesToRead: number) {
  return new Promise<Uint8Array>((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const fileBuffer = fileReader.result;
      if (!(fileBuffer instanceof ArrayBuffer)) {
        reject(new Error('Unable to read file content.'));
        return;
      }
      resolve(new Uint8Array(fileBuffer));
    };
    fileReader.onerror = () => {
      reject(new Error('Unable to read file content.'));
    };
    fileReader.readAsArrayBuffer(file.slice(0, bytesToRead));
  });
}

function startsWithSignature(fileBytes: Uint8Array, signature: readonly number[]) {
  if (fileBytes.length < signature.length) {
    return false;
  }
  return signature.every((byte, index) => fileBytes[index] === byte);
}

export async function isExecutableFile(file: unknown) {
  if (!isBlobLike(file)) {
    return false;
  }
  const fileHeaderBytes = await readFileHeaderBytes(file, WINDOWS_EXECUTABLE_MAGIC_NUMBER.length);
  return startsWithSignature(fileHeaderBytes, WINDOWS_EXECUTABLE_MAGIC_NUMBER);
}

export async function validateNoExecutableFiles(fileList?: FileList | Blob[] | null) {
  if (!fileList || fileList.length === 0) {
    return true;
  }

  for (let i = 0; i < fileList.length; i++) {
    if (await isExecutableFile(fileList[i])) {
      return executableUploadBlockedMessage;
    }
  }

  return true;
}
